import { forwardRef } from 'react';
import { Input, InputRef } from 'antd';
import searchIcon from 'assets/icons/search-icon-main.svg';
import { styled } from 'styled-components';

import { ClearButton } from '../../clearButton';
import { ISearchInputProps } from '../models/types';
import { SearchInputProvider } from '../providers';

import styles from './styles.module.scss';

const StyledInput = styled(Input)`
  height: 55px;
  font-size: 18px;
  box-sizing: border-box;
  border: 2px solid var(--black-10-10);
  box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  touch-action: manipulation;
  &:focus {
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  &:focus-visible {
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  &:focus-within {
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  &:hover {
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  @media (max-width: 800px) {
    height: 45px;
    font-size: 14px;
  }
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const SearchInput = forwardRef<InputRef, ISearchInputProps>(
  ({ placeholder, value, onChange, isLoading, style, onClearClick }, ref) => {
    return (
      <div className={styles['search-input']}>
        <SearchInputProvider>
          <StyledInput
            ref={ref}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={{
              ...style,
              zIndex: 0,
            }}
            suffix={
              value ? (
                <ClearButton
                  className={styles['search-input__button']}
                  onClick={onClearClick}
                />
              ) : (
                <img
                  src={searchIcon}
                  alt="search"
                  className={styles['search-input__button']}
                  style={{
                    cursor: 'auto',
                  }}
                />
              )
            }
          />
        </SearchInputProvider>
        {isLoading && (
          <div className={styles['search-input__loading-bar']}>
            <div className={styles['search-input__loading-content']}></div>
          </div>
        )}
      </div>
    );
  },
);
